<template>
  <section class="storefront-summary">
    <div class="head" v-if="last_update">
      <div class="top" v-if="!is_hide_date">
        <Dropdown
          v-if="can_toggle_sortlink && show_data_dropdown"
          :items="data_source_items"
          :direction_type="'left'"
          :icon_direction_type="'right'"
          :default_value="data_source_default_index"
          :key="'top-' + sortlink_data"
          @update-dropdown="onDataSourceChange"
        />

        <!-- <time>Updated: {{ last_update }}</time> -->
        <DatePicker
          v-show="!is_loading_data && show_date_picker"
          @update-date="updateDate"
          :date_range="date_range"
          ref="date_picker"
        />
      </div>
      <div class="bot">
        <!-- <span>{{ is_link_only? 'Summary': title.title }}</span> -->
      </div>
    </div>
    <div class="title" v-else>
      <Dropdown
        v-if="can_toggle_sortlink && !show_last_datetime && show_data_dropdown"
        :items="data_source_items"
        :direction_type="'left'"
        :icon_direction_type="'right'"
        :default_value="data_source_default_index"
        :key="'bot-' + sortlink_data"
        @update-dropdown="onDataSourceChange"
      />
      <DatePicker
        v-if="!is_hide_date"
        v-show="!is_loading_data && show_date_picker"
        @update-date="updateDate"
        :date_range="date_range"
        ref="date_picker"
      />
      <el-button
        class="the-curated-btn"
        @click="ClickCurated"
        v-if="one_product && now_merchant.is_enable_storefront_curation && !is_link_only"
      >
        <Checkbox size="small" :checked="curated_check" />
        Curated only
      </el-button>
    </div>
    <div class="chart-box">

      <div class="type-box" v-if="data">
        <SValue
          :chart_type="chart_type"
          :chart_type_text="'view'"
          @clickType="clickType"
          :sum="data.page_views_sum"
          :trend="data.page_views_trend"
          :value_text="title.view"
          :show_sortlink="false"
          v-if="show_views"
        />

        <SValue
          :chart_type="chart_type"
          :chart_type_text="'click'"
          @clickType="clickType"
          :sum="data.all_click"
          :trend="data.click_trend"
          :value_text="title.click"
          :show_sortlink="sortlink_data === 'all' && can_toggle_sortlink && show_views"
          :sort_value="data.short_link_click_sum"
          :store_value="data.click_sum"
        />

        <SValue
          :chart_type="chart_type"
          :chart_type_text="'tran'"
          @clickType="clickType"
          :sum="data.all_sales"
          :trend="data.sales_trend"
          :value_text="title.sale"
          :show_sortlink="sortlink_data === 'all' && can_toggle_sortlink && show_views"
          :sort_value="data.short_link_sales_sum"
          :store_value="data.sales_sum"
        />

        <SValue
          :chart_type="chart_type"
          :chart_type_text="'sales'"
          @clickType="clickType"
          :sum="data.all_sales_value"
          :trend="data.sales_value_trend"
          :value_text="title.sale_value"
          :show_sortlink="sortlink_data === 'all' && can_toggle_sortlink && show_views"
          :sort_value="handleOneNumber(data.short_link_sales_value_sum)"
          :store_value="handleOneNumber(data.sales_value_sum)"
        />

        <SValue
          :chart_type="chart_type"
          :chart_type_text="'earnings'"
          @clickType="clickType"
          :sum="data.all_earnings"
          :trend="data.earnings_trend"
          value_text="Creator Earnings"
          :show_sortlink="sortlink_data === 'all' && can_toggle_sortlink && show_views"
          :sort_value="handleOneNumber(data.short_link_earnings_sum)"
          :store_value="handleOneNumber(data.earnings_sum)"
        />
      </div>

      <Loading class="summary-loading" v-if="is_loading_data" />
      <!-- v-if="is_loading_data" -->
      <div
        id="chart_summary"
        class="chart"
        ref="chart"
        v-show="
          (chart_type === 'view' && data.page_views_sum !== 0) ||
          (chart_type === 'click' && data.all_click !== 0) ||
          (chart_type === 'tran' && data.all_sales !== 0) ||
          (chart_type === 'earnings' && data.all_earnings !== 0) ||
          (chart_type === 'sales' && data.all_sales_value !== 0)
        "
      ></div>

      <!-- Chart Legend -->
      <div class="chart-legend" v-if="chart_type !== 'view' && sortlink_data === 'all' && data && show_views">
        <div 
          class="legend-item" 
          :class="{ active: show_storefront, disabled: !hasStorefrontData() }"
          @click="toggleStorefront"
        >
          <span class="legend-color" style="background: #5AA4C3;"></span>
          <span class="legend-text">Storefront</span>
        </div>
        <div 
          class="legend-item" 
          :class="{ active: show_shortlink, disabled: !hasShortlinkData() }"
          @click="toggleShortlink"
        >
          <span class="legend-color" style="background: #EDDE54;"></span>
          <span class="legend-text">Shortlinks</span>
        </div>
      </div>

      <NoData
        v-if="
          !is_loading_data &&
          ((chart_type === 'view' && data.page_views_sum === 0) ||
            (chart_type === 'click' && data.all_click === 0) ||
            (chart_type === 'tran' && data.all_sales === 0) ||
            (chart_type === 'earnings' && data.all_earnings === 0) ||
            (chart_type === 'sales' && data.all_sales_value === 0))
        "
        :image="require('@/assets/images/data.png')"
        title="No data available"
      />
    </div>
  </section>

  <EngagementPosts ref="posts" :is_show_crt="is_show_crt" />
</template>

<script>
import DatePicker from '@/components/ui/DatePicker.vue';
import formatMoney from '@/utils/formatMoney';
import moment from 'moment';
import * as echarts from 'echarts';
import NoData from '@/components/creator/NoData.vue';
import Loading from '../ui/Loading.vue';
import EngagementPosts from '@/components/EngagementPosts.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import SValue from '@/components/summary/SummaryValue.vue';
import { ElButton } from 'element-plus';
import { dataSourceToApi } from '@/utils/SwitchFun';
import Checkbox from '@/components/ui/Checkbox.vue';

export default {
  name: 'StorefrontSummary',
  emits: ['update-data', 'update-creator-modal-date', 'handleSortLink'],

  components: {
    DatePicker,
    NoData,
    Loading,
    EngagementPosts,
    Dropdown,
    SValue,
    ElButton,
    Checkbox,
  },

  data() {
    return {
      option: null,
      chart: null,
      is_loading_data: false,
      is_checked_organic: true,
      is_checked_paid: true,
      data: false,
      data_clicks: [],
      data_sales: [],
      data_transactions: [],
      data_views: [],
      chart_type: 'view',
      is_change: false,
      start_date: moment().add(-30, 'days').toDate(),
      end_date: moment().add(-1, 'days').toDate(),
      can_toggle_sortlink: true, // hide temp. 
      sortlink_data: 'all',
      data_source_items: [
        { text: 'All Data', value: 'all' },
        { text: 'Storefront Data', value: 'storefront' },
        { text: 'Shortlinks Data', value: 'shortlink' },
      ],
      curated_check: false,
      show_storefront: true,
      show_shortlink: true,
      creator_has_historical_storefront_tracking: false,
      first_time: true,
    };
  },

  props: {
    is_hide_date: {
      type: Boolean,
      default: false,
    },
    is_link_only: {
      type: Boolean,
      default: false,
    },
    is_show_posts: {
      type: Boolean,
      default: true,
    },

    last_update: {
      type: String,
      default: '',
    },

    user_id: {
      type: [String, Number],
      default: '',
    },

    show_date_picker: {
      type: Boolean,
      default: false,
    },

    date_range: {
      type: Object,
      default: null,
    },
    title: {
      type: Object,
      default: {
        title: '',
        view: 'Page Views',
        click: 'Clicks',
        sale: 'Sales',
        sale_value: 'Sales Value',
      },
    },
    api_url: {
      type: String,
      default: '/analytics/merchant-account-statistic',
    },
    product_id: {
      type: [String, Number],
      default: '',
    },
    products_num: {
      type: [Object, Array],
      default: [],
    },
    is_show_crt: {
      type: Boolean,
      default: false,
    },
    init_sortlink: {
      type: [Boolean, Number],
      default: undefined,
    },

    show_last_datetime: {
      type: Boolean,
      default: false,
    },

    one_product: {
      type: Boolean,
      default: false,
    },

    selected_creator_tags: {
      type: Array,
      default: () => [],
    },
    creator_tag_operation_type: {
      type: String,
      default: 'or',
    },
    user_data: {
      type: Object,
      default: null,
    },
    show_views_prop: {
      type: Boolean,
      default: null,
    },
  },

  watch: {
    is_link_only(newVal) {
      console.log('1')
      if (!this.show_views) {
        this.chart_type = 'click';
      } else {
        this.chart_type = 'view';
      }
      if (this.data) {
        this.recomputeSummary();
        this.clickType(this.chart_type);
      }
    },
    sortlink_data(newVal) {
      console.log('2')
      if (newVal === 'shortlink' && this.chart_type === 'view') {
        this.chart_type = 'click';
      }
      if (this.data) {
        this.recomputeSummary();
        this.clickType(this.chart_type);
      }
    },
  },

  computed: {
    data_source_default_index() {
      return this.data_source_items.findIndex((item) => item.value === this.sortlink_data);
    },
    permission_creator() {
      return this.$store.state.user_data?.permission_list?.creatorManagement;
    },
    now_merchant() {
      return this.$store.state.user_data.merchant_account;
    },
    has_historical_storefront_tracking() {
      if (this.$store.state.list_has_historical_storefront_tracking) {
        return this.data.page_views_sum;
      }
      return false;
    },
    show_views(){
      if (this.show_views_prop !== null) return this.show_views_prop;
      if (this.sortlink_data === 'shortlink') return false;
      if (!this.user_data) {
        return !this.is_link_only || (this.is_link_only && this.$store.state.list_has_historical_storefront_tracking);
      }
      const creator_was_storefront = this.user_data.platform_type === 'storefront' || this.data.page_views_sum;
      if ((!this.is_link_only && creator_was_storefront)
      || (this.is_link_only && this.has_historical_storefront_tracking && this.data.page_views_sum)) {
        return true;
      }
      return false
    },
    show_data_dropdown(){
      if (!this.user_data) {
        return !this.is_link_only;
      }
      const creator_was_storefront = this.user_data.platform_type === 'storefront' || this.data.page_views_sum;
      if ((!this.is_link_only && creator_was_storefront)
      || (this.is_link_only && this.has_historical_storefront_tracking)
      ) {
        return true;
      }
      return false
    }
  },

  methods: {
    formatMoney: formatMoney,

    // 数据源优先级：显式选择的 sortlink_data 优先于 is_link_only；is_link_only 仅作兜底默认
    sourceMode() {
      if (this.sortlink_data === 'all') return 'all';
      if (this.sortlink_data === 'storefront') return 'storefront';
      if (this.sortlink_data === 'shortlink') return 'shortlink';
      return this.is_link_only ? 'shortlink' : 'storefront';
    },

    recomputeSummary() {
      if (!this.data) return;
      let da = this.data;
      const mode = this.sourceMode();
      if (mode === 'all') {
        this.data.all_click = da.click_sum + da.short_link_click_sum;
        this.data.all_sales = da.sales_sum + da.short_link_sales_sum;
        this.data.all_sales_value = this.one_product
          ? this.handleNumberPlus(da.sales_value_sum, da.short_link_sales_value_sum)
          : Math.ceil(da.sales_value_sum) + Math.ceil(da.short_link_sales_value_sum);
        this.data.all_earnings = this.one_product
          ? this.handleNumberPlus(da.earnings_sum, da.short_link_earnings_sum)
          : Math.ceil(da.earnings_sum) + Math.ceil(da.short_link_earnings_sum);
      } else if (mode === 'shortlink') {
        this.data.all_click = da.short_link_click_sum;
        this.data.all_sales = da.short_link_sales_sum;
        this.data.all_sales_value = this.one_product
          ? this.handleNumberPlus(da.short_link_sales_value_sum)
          : Math.ceil(da.short_link_sales_value_sum);
        this.data.all_earnings = this.one_product
          ? this.handleNumberPlus(da.short_link_earnings_sum)
          : Math.ceil(da.short_link_earnings_sum);
      } else {
        this.data.all_click = da.click_sum;
        this.data.all_sales = da.sales_sum;
        this.data.all_sales_value = this.one_product
          ? this.handleNumberPlus(da.sales_value_sum)
          : Math.ceil(da.sales_value_sum);
        this.data.all_earnings = this.one_product
          ? this.handleNumberPlus(da.earnings_sum)
          : Math.ceil(da.earnings_sum);
      }
    },

    onDataSourceChange(item) {
      this.sortlink_data = item.value;
      console.log('3')
      this.chart_type = item.value === 'shortlink' ? 'click' : 'view';
      this.$emit('handleSortLink', this.sortlink_data);
      this.getData();
    },

    setOption() {
      this.option = {};
    },

    handleOneNumber(val) {
      const num = parseFloat(val);
      return isNaN(num) || val === undefined ? 0 : Math.round(num);
    },

    handleNumberPlus(val1, val2) {
      const parseNumber = (val) => {
        const num = parseFloat(val);
        return isNaN(num) || val === undefined ? 0 : num;
      };

      const sales = parseNumber(val1);
      const shortLinkSales = parseNumber(val2);
      const total = sales + shortLinkSales;

      return Math.round(total).toLocaleString('en-US');
    },

    getData(type = 'view') {
      if (this.$store.state.user_data.merchant_account_id) {
        let s = moment(this.start_date).format('YYYY-MM-DD');
        let e = moment(this.end_date).format('YYYY-MM-DD');

        let date_time = `?start_date=${s}&end_date=${e}`;
        let create_id = this.user_id ? `&creator_user_id=${this.user_id}` : '';
        let product_id = this.product_id ? `&product_id=${this.product_id}` : '';

        //因為不管如何我都要先知道有sortlink=1的時候有沒有資料，所以這邊強行都CALL 1，但顯示不顯示由前端操控
        let api = `${
          this.api_url
        }${date_time}${create_id}${product_id}&is_include_shortlink_data=${dataSourceToApi(this.sortlink_data)}&is_include_curation_data=${
          this.curated_check ? '1' : '0'
        }`;

        // Add creator tag filters
        if (this.selected_creator_tags && this.selected_creator_tags.length > 0) {
          this.selected_creator_tags.forEach((tag) => {
            api += `&creator_tag_ids[]=${tag.id}`;
          });
          api += `&operation_type=${this.creator_tag_operation_type}`;
        }

        // let api = `/analytics/merchant-account-statistic?type=${type}`;
        // if (this.user_id) api = `${api}&user_id=${this.user_id}`;

        this.is_loading = true;
        this.is_loading_data = true;

        this.$ajax(api, {
          method: 'get',
          withCredentials: true,
        }).then((res) => {
          let sv = res.data.data.sales_value_rows;
          if( res.data.data.has_historical_storefront_tracking ){
            if(this.user_data){
              this.creator_has_historical_storefront_tracking = res.data.data.has_historical_storefront_tracking;
            }else{
              this.$store.state.list_has_historical_storefront_tracking = res.data.data.has_historical_storefront_tracking;
            }
          }
          
          for (let i in sv) {
            sv[i].total_count = Number(sv[i].total_count).toFixed(2);
          }

          // 10353
          if (!res.data.data.short_link_earnings_sum && res.data.data.shortlink_earnings_sum) {
            res.data.data.short_link_earnings_sum = res.data.data.shortlink_earnings_sum;
          }

          this.data = res.data.data;
          let da = this.data;
          this.recomputeSummary();

          // this.can_toggle_sortlink = da.short_link_click_sum + da.short_link_sales_sum + da.short_link_sales_value_sum;

          let data = [];
          let date = [];

          data = this.handleChartZone(this.data.page_views_rows).data;
          date = this.handleChartZone(this.data.page_views_rows).date;
          for (let i in date) {
            date[i] = moment(date[i]).format('MMM DD, YYYY');
          }
          this.option.xAxis[0].data = date;
          this.option.series[0].data = data;

          if (this.$refs.chart) {
            const chart = echarts.init(this.$refs.chart);
            chart.setOption(this.option);

            setTimeout(() => {

              this.is_loading = false;
              this.is_loading_data = false;

              if( this.first_time ){
                console.log('4')
                this.chart_type = !this.show_views ? 'click' : 'view';
                this.first_time = false;
              }
              console.log('this.show_views',this.show_views)
              console.log('chart_type after data load', this.chart_type);
              this.clickType(this.chart_type);
              // console.log('this.chart_type', this.chart_type)

              if (this.is_show_posts && this.$store.state.user_data.is_motom_internal_user) {
                chart.on('click', (params) => {
                  if (params.name) {
                    this.$refs.posts.show(params, this.user_id ? this.user_id : null, date, {
                      start_date: moment(this.start_date).format('YYYY-MM-DD'),
                      end_date: moment(this.end_date).format('YYYY-MM-DD'),
                    });
                  }
                });
              }

              this.$emit('update-data', res.data);
            }, 300);
          }
        });
      }
    },

    initOption() {
      let vi = this;
      this.first_time = true;
      this.sortlink_data = this.init_sortlink !== undefined ? this.init_sortlink : this.$store.state.save_sortlink_data; //放入預設

      this.option = {
        color: ['#000000'],
        tooltip: {
          show: true,
          trigger: 'axis',
          extraCssText:
            'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3); padding: 5px 10px; font-size: 12px; line-height: 20px; border-radius: 4px;',
          axisPointer: {
            type: 'line',
            snap: true,
            lineStyle: {
              width: 1,
              color: '#232A60',
              type: 'solid',
            },
            label: {
              componentType: 'series',
              show: true,
              backgroundColor: '#78CBFA',
            },
          },
          formatter: function (params) {
            let content = moment(params[0].axisValue).format('MMM DD, YYYY') + '<br>';
            let title = '●';
            if (vi.chart_type == 'sales' || vi.chart_type == 'earnings') {
              title = '$';
            }

            if (vi.chart_type !== 'view' && vi.sortlink_data === 'all' && params.length > 1) {
              let total = 0;
              params.forEach(function (item) {
                total += parseFloat(item.value) || 0;
              });
              
              if (vi.chart_type == 'sales' || vi.chart_type == 'earnings') {
                let totalVal = Math.round(total).toLocaleString('en-US');
                content += `<strong>Total: $${totalVal}</strong><br>`;
              } else {
                content += `<strong>Total: ${Math.ceil(total).toLocaleString()}</strong><br>`;
              }
            }

            params.forEach(function (item, key) {
              let which = key === 0 ? 'Storefront' : 'Links';
              //one_product
              if (vi.chart_type === 'view' || vi.sortlink_data !== 'all') {
                if (vi.chart_type == 'sales' || vi.chart_type == 'earnings') {
                  let val = Math.round(Number(item.value) || 0).toLocaleString('en-US');
                  content += `${title} ${val} <br>`;
                } else {
                  content += `${title} ${Math.ceil(item.value).toLocaleString()} <br>`;
                }
              } else {
                if (vi.chart_type == 'sales' || vi.chart_type == 'earnings') {
                  let val = Math.round(Number(item.value) || 0).toLocaleString('en-US');
                  content += `${which}: $${val} <br>`;
                } else {
                  content += `${which}: ${Math.ceil(item.value).toLocaleString()} <br>`;
                }
              }
            });
            return content;
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: {
              formatter: (params) => {
                return moment(params).format('MMM DD');
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            alignTicks: false,
          },
        ],
        series: [
          {
            type: 'line',
            stack: 'Total',
            smooth: true,
            symbol: 'circle',
            symbolSize: 20,
            itemStyle: {
              color: '#232A60',
              borderWidth: 6,
              borderColor: 'rgba(176, 216, 246)',
            },
            triggerLineEvent: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              // opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#5AA4C3',
                },
                {
                  offset: 1,
                  color: '#90D2ED' // 'rgba(120, 203, 250, 0.7)', //'#78CBFA'
                },
              ]),
            },
            emphasis: {
              focus: 'series',
            },
            data: [],
          },
          //2
          {
            type: 'line',
            stack: 'Total',
            smooth: true,
            symbol: 'circle',
            symbolSize: 20,
            itemStyle: {
              color: '#232A60',
              borderWidth: 6,
              borderColor: 'rgba(176, 216, 246)',
            },
            triggerLineEvent: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              // opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#EDDE54',
                },
                {
                  offset: 1,
                  color: '#EDDE54', //'#78CBFA'
                },
              ]),
            },
            emphasis: {
              focus: 'series',
            },
            data: [],
          },
        ],
      };
    },

    resizeChart() {
      this.$nextTick(() => {
        if (this.$refs.chart) {
          const chart = echarts.init(this.$refs.chart);
          chart.setOption(this.option);
          chart.resize();
        }
      });
    },

    handleChartZone(arr) {
      let data = [];
      let date = [];
      let last = null;

      arr.forEach((item) => {
        const pushData = () => {
          data.push(item.total_count);
          date.push(item.event_date);
          last = item.event_date;
        };

        if (last !== item.event_date) {
          pushData();
        } else {
          data.splice(-1, 1);
          date.splice(-1, 1);
          pushData();
        }
      });
      return { data: data, date: date };
    },

    clickType(type) {
      this.chart_type = type;
      let data = [];
      let date = [];
      let o = {};
      let data2 = [];
      const useShortlink = this.sourceMode() === 'shortlink';

      switch (type) {
        case 'view':
          o = this.handleChartZone(this.data.page_views_rows);
          break;

        case 'click':
          if (useShortlink) {
            o = this.handleChartZone(this.data.short_link_clicks_rows);
          } else {
            o = this.handleChartZone(this.data.clicks_rows);
            data2 = this.handleChartZone(this.data.short_link_clicks_rows).data;
          }
          break;

        case 'tran':
          if (useShortlink) {
            o = this.handleChartZone(this.data.short_link_sales_rows);
          } else {
            o = this.handleChartZone(this.data.sales_rows);
            data2 = this.handleChartZone(this.data.short_link_sales_rows).data;
          }
          break;

        case 'sales':
          if (useShortlink) {
            o = this.handleChartZone(this.data.short_link_sales_value_rows);
          } else {
            o = this.handleChartZone(this.data.sales_value_rows);
            data2 = this.handleChartZone(this.data.short_link_sales_value_rows).data;
          }
          break;

        case 'earnings':
          if (useShortlink) {
            o = this.handleChartZone(this.data.short_link_earnings_rows);
          } else {
            o = this.handleChartZone(this.data.earnings_rows);
            data2 = this.handleChartZone(this.data.short_link_earnings_rows).data;
          }
          break;
      }

      // console.log(this.data.page_views_rows)

      data = o.data;
      date = o.date;

      for (let i in date) {
        date[i] = moment(date[i]).format('MMM DD, YYYY');
      }
      this.option.xAxis[0].data = date;
      // show_storefront / show_shortlink 只在 'all' 模式有图例可切换；单源模式下 series[0] 必须始终渲染，否则切回后无法恢复
      const legendActive = type !== 'view' && this.sortlink_data === 'all';
      this.option.series[0].data = !legendActive || this.show_storefront ? data : [];
      //2
      this.option.series[1].data = legendActive && this.show_shortlink ? data2 : [];

      const blueGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: '#5AA4C3' },
        { offset: 1, color: '#90D2ED' },
      ]);
      const yellowGradient = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: '#EDDE54' },
        { offset: 1, color: '#EDDE54' },
      ]);
      const series0IsShortlink = type !== 'view' && useShortlink;
      this.option.series[0].areaStyle.color = series0IsShortlink ? yellowGradient : blueGradient;

      const chart = echarts.init(this.$refs.chart);
      chart.setOption(this.option);
    },

    updateDate(obj) {
      this.start_date = obj.start_date;
      this.end_date = obj.end_date;
      this.getData();
      this.$emit('update-creator-modal-date', obj);
    },

    ClickCurated() {
      this.curated_check = !this.curated_check;
      this.getData();
      let obj = {
        start_date: this.start_date,
        end_date: this.end_date,
        curated_check: this.curated_check,
      };
      this.$emit('update-creator-modal-date', obj);
    },

    hasStorefrontData() {
      if (!this.data) return false;
      
      switch (this.chart_type) {
        case 'click':
          return this.data.click_sum > 0;
        case 'tran':
          return this.data.sales_sum > 0;
        case 'sales':
          return this.data.sales_value_sum > 0;
        case 'earnings':
          return this.data.earnings_sum > 0;
        default:
          return false;
      }
    },

    hasShortlinkData() {
      if (!this.data) return false;
      
      switch (this.chart_type) {
        case 'click':
          return this.data.short_link_click_sum > 0;
        case 'tran':
          return this.data.short_link_sales_sum > 0;
        case 'sales':
          return this.data.short_link_sales_value_sum > 0;
        case 'earnings':
          return this.data.short_link_earnings_sum > 0;
        default:
          return false;
      }
    },

    toggleStorefront() {
      if (!this.hasStorefrontData()) return;
      this.show_storefront = !this.show_storefront;
      this.updateChartVisibility();
    },

    toggleShortlink() {
      if (!this.hasShortlinkData()) return;
      this.show_shortlink = !this.show_shortlink;
      this.updateChartVisibility();
    },

    updateChartVisibility() {
      if (!this.$refs.chart) return;
      
      const chart = echarts.init(this.$refs.chart);
      let data = [];
      let data2 = [];

      switch (this.chart_type) {
        case 'click':
          data = this.handleChartZone(this.data.clicks_rows).data;
          data2 = this.handleChartZone(this.data.short_link_clicks_rows).data;
          break;
        case 'tran':
          data = this.handleChartZone(this.data.sales_rows).data;
          data2 = this.handleChartZone(this.data.short_link_sales_rows).data;
          break;
        case 'sales':
          data = this.handleChartZone(this.data.sales_value_rows).data;
          data2 = this.handleChartZone(this.data.short_link_sales_value_rows).data;
          break;
        case 'earnings':
          data = this.handleChartZone(this.data.earnings_rows).data;
          data2 = this.handleChartZone(this.data.short_link_earnings_rows).data;
          break;
      }

      this.option.series[0].data = this.show_storefront ? data : [];
      this.option.series[1].data = this.show_shortlink && this.sortlink_data === 'all' ? data2 : [];
      
      chart.setOption(this.option);
    },
  },

  mounted() {
    // If is_link_only, default to 'click' instead of 'view' since view tab is hidden
    if (this.is_link_only && !this.show_views) {
      this.chart_type = 'click';
    }

    this.initOption();

    // console.log(this.date_range)
    if (this.date_range) {
      // this.$refs.date_picker.custom_date = [this.date_range.start_date, this.date_range.end_date];
      this.start_date = this.date_range.start_date;
      this.end_date = this.date_range.end_date;

      // setTimeout(() => {
      //     this.$refs.date_picker.setDate([this.date_range.start_date, this.date_range.end_date]);

      // }, 1000);
    }

    this.getData();

    this.EventBus.off('update-date-at-analytics');
    this.EventBus.on('update-date-at-analytics', (obj) => {
      this.updateDate(obj);
    });
  },

  created() {
    window.addEventListener('resize', this.resizeChart);
  },

  destroyed() {
    window.removeEventListener('resize', this.resizeChart);
  },
};
</script>
<style lang="scss">
.storefront-summary {
  margin-bottom: 24px;

  .head {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row-reverse;

    .top {
      display: flex;
      align-items: center;
      margin: 16px 0px 8px 8px;
      pointer-events: none;
      justify-content: flex-end;
      position: relative;
      //margin-top: -56px;
      height: 32px;
      gap: 12px;

      & * {
        pointer-events: auto;
      }

      .ui-checkbox {
        margin-right: 8px;
      }
    }

    .bot {
      margin: 16px 0 16px 0;
      display: flex;
      align-items: center;
      flex: 1;

      & > span {
        font: var(--font-demi-20);
        color: var(--black-90);
        flex: 1;
      }
    }

    @media (max-width: 950px) {
      display: block;
    }
  }

  .the-curated-btn {
    margin-left: 8px;
    padding-left: 9px;
    padding-right: 9px;
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 8px;
    // min-height: 38px;

    .title-span {
      font: var(--font-demi-20);
      color: var(--black-90);
    }

    span {
      flex: 1;
    }

    .ui-date-picker {
      margin-left: 8px;
    }

    .update-time {
      margin-right: 4px;
    }
  }

  .chart-box {
    background: var(--bg-02);
    // margin-top: 8px;
    overflow: hidden;
    position: relative;

    .creator-no-data img {
      width: 120px;
    }

    .type-box {
      display: flex;
      cursor: pointer;
    }

    .chart {
      width: auto;
      height: 300px;
      padding-bottom: 60px;
    }

    .summary-loading {
      position: absolute;
    }

    .chart-legend {
      display: flex;
      gap: 16px;
      position: absolute;
      left: 16px;
      bottom: 16px;

      .legend-item {
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        user-select: none;
        opacity: 1;
        transition: opacity 0.2s;
        color: var(--black-90);
        font: var(--font-med-12);

        &.disabled {
          cursor: not-allowed;
          color: var(--black-40);

          .legend-color {
            background: #eee !important;
          }
        }

        &:not(.active) {
          color: var(--black-60);

          .legend-color {
            background: #ccc !important;
          }
        }

        .legend-color {
          width: 24px;
          height: 12px;
          transition: background 0.2s;
        }
      }
    }
  }
}
</style>
